var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive-sm",attrs:{"id":"ExposureRentalAgreement"}},[_c('section',[_c('vue-good-table',{ref:"listAssetTable",attrs:{"title":"Asset","columns":_vm.columns,"rows":_vm.rows,"max-height":"600px","totalRows":_vm.totalRecords,"pagination-options":{
                enabled: true,
                position:'top',
                mode: 'records',
                perPage: 50,
                perPageDropdown:[50,100],
                dropdownAllowAll: false,
            },"search-options":{
                enabled: false,
                placeholder: 'Search Asset',
            },"select-options":{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
            },"sort-options":{
                enabled: true,
            }}},[_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_vm._v("\n        No Data Found.\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c3ae91c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/CustomerExposureRentalAgreement.vue
// module id = null
// module chunks = 